import React, {Fragment} from 'react';
import {translate} from "react-i18next";
import CompanyApi from "../../apis/CompanyApi";
import {companiesUpdated} from "../../actions/companyAction";
import {connect} from "react-redux";
import MaskedInput from "react-text-mask";
import {createNumberMask} from "text-mask-addons/dist/textMaskAddons";

class EditQuota extends React.Component {

    state = {
        loading: false,
        isOpen: false,
        company: null,
        companyProject: null,
        workType: '',
        amount: '',
        amountUnlimited: false,
        pay: '',
        nightStart: '',
        nightEnd: '',
        nightExtra: '',
        sundayExtra: '',
        bankHolidayExtra: '',
        errors: {}
    };

    componentDidMount() {
        this.setState({
            company: this.props.company,
            companyProject: this.props.companyProject
        });
    }

    open = () => {
        let {quota, companyProject} = this.props;
        this.setState({
            isOpen: true,
            companyProject: companyProject,
            workType: quota.workType.id,
            amount: quota.amount,
            amountUnlimited: quota.amountUnlimited,
            pay: quota.pay ? quota.pay.toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) : '',
            nightStart: quota.nightStart,
            nightEnd: quota.nightEnd,
            nightExtra: quota.nightExtra,
            sundayExtra: quota.sundayExtra,
            bankHolidayExtra: quota.bankHolidayExtra
        });
    };

    cancel = () => {
        this.setState({
            isOpen: false,
            workType: null,
            amount: '',
            amountUnlimited: false,
            pay: '',
            nightStart: '',
            nightEnd: '',
            nightExtra: '',
            sundayExtra: '',
            bankHolidayExtra: '',
            errors: {}
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({loading: true, errors: {}});
        CompanyApi.updateCompanyProjectQuota(this.props.quota.id, this.state.workType, this.state.amount, this.state.amountUnlimited, this.state.pay, this.state.nightStart, this.state.nightEnd, this.state.nightExtra, this.state.sundayExtra, this.state.bankHolidayExtra)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({loading: false});
                    if (response.data.success === true) {
                        this.cancel();
                        this.props.companiesUpdated();
                        this.props.onSuccess();
                    } else {
                        this.setState({errors: response.data.errors});
                    }
                }
            })
    };

    render() {
        const {t, quota} = this.props;
        return (
            <Fragment>
                <button className="btn btn-xs btn-primary" onClick={this.open}>
                    <i className="fa fa-pencil"/>
                </button>
                {this.state.isOpen ? (
                    <div className="AddQuotaDialog modal inmodal in text-left" tabIndex="-1" role="dialog"
                         style={{display: 'block'}}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button className="close" onClick={this.cancel}>
                                        <span>x</span>
                                    </button>
                                    <h4 className="modal-title">
                                        {t('company.companyProject.quota.edit')}
                                    </h4>
                                </div>
                                <form onSubmit={this.handleSubmit}>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-8">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.workType) ? ' has-error' : '')}>
                                                    <label>{t('company.quota.add.dialog.workType.label')}</label>
                                                    <select className="form-control" value={this.state.workType}
                                                            onChange={(e) => this.setState({workType: e.target.value})}>
                                                        <Fragment>
                                                            <option/>
                                                            {this.state.companyProject.workTypesNotQuoted.map((workType, wtK) => (
                                                                <option key={wtK} value={workType.id}>
                                                                    {workType.name}
                                                                </option>
                                                            ))}
                                                            <option key={999} value={quota.workType.id}>
                                                                {quota.workType.name}
                                                            </option>
                                                        </Fragment>
                                                    </select>
                                                    {(this.state.errors && this.state.errors.workType) ? (
                                                        <span className="help-block">
                                                            {t('company.quota.add.dialog.workType.error.' + this.state.errors.workType)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.amount) ? ' has-error' : '')}>
                                                    <label>{t('company.quota.add.dialog.amount.label')}</label>
                                                    <MaskedInput className="form-control" type="text" name="amount"
                                                                 mask={createNumberMask({
                                                                     prefix: '',
                                                                     includeThousandsSeparator: false,
                                                                     integerLimit: 4
                                                                 })}
                                                                 value={this.state.amount}
                                                                 disabled={this.state.amountUnlimited}
                                                                 onChange={(e) => this.setState({amount: e.target.value})}/>
                                                    <input type="checkbox"
                                                           checked={this.state.amountUnlimited} name="amountUnlimited"
                                                           id="amountUnlimited-checkbox"
                                                           onChange={(e) => this.setState({amountUnlimited: e.target.checked})}/>
                                                    <label htmlFor="amountUnlimited-checkbox">
                                                        &nbsp;{t('company.quota.add.dialog.amountUnlimited.label')}
                                                    </label>
                                                    {(this.state.errors && this.state.errors.amount) ? (
                                                        <span className="help-block">
                                                            {t('company.quota.add.dialog.amount.error.' + this.state.errors.amount)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.pay) ? ' has-error' : '')}>
                                                    <label>{t('company.quota.add.dialog.pay.label')}</label>
                                                    <div className="input-group">
                                                        <MaskedInput className="form-control" type="text" name="pay"
                                                                     mask={createNumberMask({
                                                                         prefix: '',
                                                                         thousandsSeparatorSymbol: '.',
                                                                         allowDecimal: true,
                                                                         decimalSymbol: ','
                                                                     })}
                                                                     value={this.state.pay}
                                                                     onChange={(e) => this.setState({pay: e.target.value})}/>
                                                        <span className="input-group-addon">€</span>
                                                    </div>
                                                    {(this.state.errors && this.state.errors.pay) ? (
                                                        <span className="help-block">
                                                            {t('company.quota.add.dialog.pay.error.' + this.state.errors.pay)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.nightExtra) ? ' has-error' : '')}>
                                                    <label>{t('company.quota.add.dialog.nightExtra.label')}</label>
                                                    <div className="input-group">
                                                        <MaskedInput className="form-control" type="text"
                                                                     name="nightExtra"
                                                                     mask={createNumberMask({
                                                                         prefix: '',
                                                                         integerLimit: 2
                                                                     })}
                                                                     value={this.state.nightExtra}
                                                                     onChange={(e) => this.setState({nightExtra: e.target.value})}/>
                                                        <span className="input-group-addon">%</span>
                                                    </div>
                                                    {(this.state.errors && this.state.errors.nightExtra) ? (
                                                        <span className="help-block">
                                                            {t('company.quota.add.dialog.nightExtra.error.' + this.state.errors.nightExtra)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.nightStart) ? ' has-error' : '')}>
                                                    <label>{t('company.quota.add.dialog.nightStart.label')}</label>
                                                    <div className="input-group">
                                                        <MaskedInput className="form-control" type="text"
                                                                     name="nightStart"
                                                                     mask={createNumberMask({
                                                                         prefix: '',
                                                                         integerLimit: 2,
                                                                         allowLeadingZeroes: true
                                                                     })}
                                                                     value={this.state.nightStart}
                                                                     onChange={(e) => this.setState({nightStart: e.target.value})}/>
                                                        <span className="input-group-addon">Uhr</span>
                                                    </div>
                                                    {(this.state.errors && this.state.errors.nightStart) ? (
                                                        <span className="help-block">
                                                            {t('company.quota.add.dialog.nightStart.error.' + this.state.errors.nightStart)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.nightEnd) ? ' has-error' : '')}>
                                                    <label>{t('company.quota.add.dialog.nightEnd.label')}</label>
                                                    <div className="input-group">
                                                        <MaskedInput className="form-control" type="text"
                                                                     name="nightEnd"
                                                                     mask={createNumberMask({
                                                                         prefix: '',
                                                                         integerLimit: 2,
                                                                         allowLeadingZeroes: true
                                                                     })}
                                                                     value={this.state.nightEnd}
                                                                     onChange={(e) => this.setState({nightEnd: e.target.value})}/>
                                                        <span className="input-group-addon">Uhr</span>
                                                    </div>
                                                    {(this.state.errors && this.state.errors.nightEnd) ? (
                                                        <span className="help-block">
                                                            {t('company.quota.add.dialog.nightEnd.error.' + this.state.errors.nightEnd)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.sundayExtra) ? ' has-error' : '')}>
                                                    <label>{t('company.quota.add.dialog.sundayExtra.label')}</label>
                                                    <div className="input-group">
                                                        <MaskedInput className="form-control" type="text"
                                                                     name="sundayExtra"
                                                                     mask={createNumberMask({
                                                                         prefix: '',
                                                                         integerLimit: 2
                                                                     })}
                                                                     value={this.state.sundayExtra}
                                                                     onChange={(e) => this.setState({sundayExtra: e.target.value})}/>
                                                        <span className="input-group-addon">%</span>
                                                    </div>
                                                    {(this.state.errors && this.state.errors.sundayExtra) ? (
                                                        <span className="help-block">
                                                            {t('company.quota.add.dialog.sundayExtra.error.' + this.state.errors.sundayExtra)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.bankHolidayExtra) ? ' has-error' : '')}>
                                                    <label>{t('company.quota.add.dialog.bankHolidayExtra.label')}</label>
                                                    <div className="input-group">
                                                        <MaskedInput className="form-control" type="text"
                                                                     name="bankHolidayExtra" mask={createNumberMask({
                                                            prefix: '',
                                                            integerLimit: 2
                                                        })}
                                                                     value={this.state.bankHolidayExtra}
                                                                     onChange={(e) => this.setState({bankHolidayExtra: e.target.value})}/>
                                                        <span className="input-group-addon">%</span>
                                                    </div>
                                                    {(this.state.errors && this.state.errors.bankHolidayExtra) ? (
                                                        <span className="help-block">
                                                            {t('company.quota.add.dialog.bankHolidayExtra.error.' + this.state.errors.bankHolidayExtra)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-default" type="button" onClick={this.cancel}
                                                disabled={this.state.loading}>
                                            {t('default.cancel')}
                                        </button>
                                        <button className="btn btn-primary" type="submit" disabled={this.state.loading}>
                                            {this.state.loading ? (
                                                <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                            ) : null}
                                            {t('default.save')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                ) : null}
            </Fragment>
        )
    }
}

export default connect(null, {companiesUpdated})(translate()(EditQuota));
